import './styles.scss';

import React from 'react';

export enum AppProgressBarSize {
    MEDIUM = 'medium',
    BIG = 'big',
}

interface AppProgressBarProps {
    progress?: number;
    size?: AppProgressBarSize;
}

export const AppProgressBar = ({progress = 0, size = AppProgressBarSize.MEDIUM}: AppProgressBarProps) => {
    return (
        <div className={`app-progress-bar ${size}`}>
            <div className='app-progress-bar__value' style={{width: progress + '%'}}></div>
        </div>
    );
};
